import { exactPin } from '../template/consumer/contract';
export { readMissionTemplate as readMissionWorkspace } from '../template/consumer/reader';

/** Documentary exact read anchor, not a Mission identity or a successful read. */
export const workspaceQuery = exactPin({
  kind: 'MissionTemplate',
  id: 'SYN-HRF-MT-001',
  version: '1',
  schemaVersion: 'SC-HRF-SYN-1',
  canonicalizationVersion: 'SC-C14N-2',
  digest: 'aa722f0d07e634a258a46525cac5cf4ce0fbf1f7285dfccf6041e651d2244de8',
});
